export const FETCH_NODES = "FETCH_NODES";
export const ENABLE_NODE = "ENABLE_NODE";
export const SET_LOADING = "SET_LOADING";
export const REMOVE_NODE = "REMOVE_NODE";
export const GET_NODE_USERS = "GET_NODE_USERS";
export const GET_NODE_APPS = "GET_NODE_APPS";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const COLOR_PICKER = "COLOR_PICKER";
export const GET_COORDINATES = "GET_COORDINATES";
export const UPDATE_NAMES = "UPDATE_NAMES";
export const SELECT_NODE = "SELECT_NODE";
export const NODE_COLOR = "NODE_COLOR";
export const UPDATE_LOG_SCALE_MIN_MAX = "UPDATE_LOG_SCALE_MIN_MAX";
export const AVG_NODE_DATA = "AVG_NODE_DATA";
